export enum ErrorTypeEnum {
    IkkeValgtInstitution = 1,
    UniLogin = 2
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/enums/ErrorTypeEnum.ts